// extracted by mini-css-extract-plugin
export default {"popupInner":"TwoFactorAuthenticationPopup__popupInner--3gu","layout":"TwoFactorAuthenticationPopup__layout--2vr","container":"TwoFactorAuthenticationPopup__container--3Yb"};